import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaFacebook, FaTwitter, FaBehance, FaWhatsapp } from 'react-icons/fa';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    service: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSubmitted(false);
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, you would send this to a backend service
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setFormData({ name: '', email: '', subject: '', service: '', message: '' });
  };

  return (
    <main className="contact-page">
      <section className="contact-hero">
        <div className="container">
          <h1>Get in Touch</h1>
          <p>We're ready to assist you with your project needs</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-info">
              <div className="info-item">
                <div className="info-icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="info-content">
                  <h4>Our Location</h4>
                  <p>Plot 68 CAD Zone D01, Opposite Public Service Institute of Nigeria, Kubwa Express Way, FCT-Abuja</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <FaPhone />
                </div>
                <div className="info-content">
                  <h4>Phone</h4>
                  <p>+234 (0) 803 464 8000<br />+234 909 390 0039<br />+234 815 163 2434</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <FaEnvelope />
                </div>
                <div className="info-content">
                  <h4>Email</h4>
                  <p>admin@fredsonrock.com<br />mcfredconcepts@gmail.com</p>
                </div>
              </div>

              <div className="social-links">
                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" title="Facebook">
                  <FaFacebook />
                </a>
                <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" title="Twitter">
                  <FaTwitter />
                </a>
                <a href="https://www.behance.net" target="_blank" rel="noopener noreferrer" title="Behance">
                  <FaBehance />
                </a>
                <a href="https://wa.me/+2348034648000" target="_blank" rel="noopener noreferrer" title="WhatsApp">
                  <FaWhatsapp />
                </a>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  required
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  required
                  className="form-control"
                  value={formData.subject}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <select
                  name="service"
                  required
                  className="form-control"
                  value={formData.service}
                  onChange={handleChange}
                >
                  <option value="">Select Service</option>
                  <option value="construction">Construction Technology</option>
                  <option value="mining">Mining & Mining Support</option>
                  <option value="drilling">Rock Drilling & Blasting</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Your Message"
                  rows="5"
                  required
                  className="form-control"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary">Send Message</button>
              {submitted && (
                <div className="success-message" role="status" aria-live="polite">
                  Thank you! We&apos;ll get back to you soon.
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      <section className="contact-map">
        <div className="container">
          <div className="map-heading">
            <p className="map-label">Find us</p>
            <h2>Our Abuja office</h2>
            <p>Plot 68 CAD Zone D01, Opposite Public Service Institute of Nigeria, Kubwa Express Way, FCT-Abuja</p>
          </div>
          <div className="map-placeholder">
            <iframe
              title="C.U Fredson Nigeria office location"
              src="https://www.google.com/maps?q=Plot+68+CAD+Zone+D01,+Opposite+Public+Service+Institute+of+Nigeria,+Kubwa+Express+Way,+FCT-Abuja&output=embed"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <a className="map-link" href="https://maps.google.com/?q=Plot+68+CAD+Zone+D01,+Opposite+Public+Service+Institute+of+Nigeria,+Kubwa+Express+Way,+FCT-Abuja" target="_blank" rel="noopener noreferrer">
            Open in Google Maps
          </a>
        </div>
      </section>
    </main>
  );
}

export default Contact;
